import axios from 'axios.js'

export const GET_MEASUREMENT_RULES = 'GET_MEASUREMENT_RULES'
export const GET_SHIFT_RULES = 'GET_SHIFT_RULES'
export const GET_EVALUATION_RULES = 'GET_EVALUATION_RULES'


const MESUREMENT_RULE_API_URL = '/api/measurement_rules'
const MESUREMENT_RULE_EVALUATRION_API_URL = '/api/measurement_rules/evaluations'
const SHIFT_ALL_API_URL = '/api/shift/all'

export const getMeasurementsRules = (filter, paginate) => (dispatch) => {
    if(paginate!==null){
        console.log("Get All User called")
        axios.post(MESUREMENT_RULE_API_URL, filter, {params:paginate}).then((res) => {
            if(res.data.result_status === 200){
                dispatch({
                    type: GET_MEASUREMENT_RULES,
                    payload: res.data.data,
                })
            }else{
                dispatch({
                    type: GET_MEASUREMENT_RULES,
                    payload: null,
                })
            }
        })
    }
}

export const getEvaluationRules = (filter, paginate) => (dispatch) => {
    if(paginate!==null){
        console.log("Get All User called")
        axios.post(MESUREMENT_RULE_EVALUATRION_API_URL, filter, {params: paginate}).then((res) => {
            if(res.data.result_status === 200){
                dispatch({
                    type: GET_EVALUATION_RULES,
                    payload: res.data.data,
                })
            }else{
                dispatch({
                    type: GET_EVALUATION_RULES,
                    payload: null,
                })
            }
        })
    }
}

export const getShiftsRules = (filter, paginate) => (dispatch) => {
    if(paginate!==null){
        console.log("Get All User called")
        axios.post(SHIFT_ALL_API_URL, filter, {params:paginate}).then((res) => {
            if(res.data.result_status === 200){
                dispatch({
                    type: GET_SHIFT_RULES,
                    payload: res.data.data,
                })
            }else{
                dispatch({
                    type: GET_SHIFT_RULES,
                    payload: null,
                })
            }
        })
    }
}




